export const getSponsors = (state) => state.common.sponsors;
export const getStudies = (state) => state.common.studies;
export const getCustomers = (state) => state.common.customers;
export const getClientIds = (state) => state.common.clientIds;
export const getProducts = () => [{ value: "econsent", name: "econsent" }];